(function () {
  document.addEventListener('DOMContentLoaded', () => {

    // --- DOM Elements ---
    const womanSelect       = document.getElementById('woman-1');
    const manSelect         = document.getElementById('man-1');
    const womanHidden       = document.getElementById('size-woman');
    const manHidden         = document.getElementById('size-man');
    const atcButton         = document.getElementById('wedding-atc');
    const atcOverlay        = document.getElementById('atc-overlay');
    const validationMessage = document.getElementById('validation-message');
    const selectedSizeDiv   = document.getElementById('selected-size');
    const totalWeightDiv    = document.getElementById('total-weight');
    const infPrice          = document.querySelector('.price-item.price-item--regular');
    const weddingPrice      = document.getElementById('wedding_price');

    weddingPrice.textContent = infPrice ? infPrice.textContent.trim() : '';

    // --- Sizes ---
    const manSizes = [
      "14 | 55mm | ø 17.2mm","15 | 56mm | ø 17.5mm","16 | 57mm | ø 17.8mm","17 | 58mm | ø 18.2mm","18 | 59mm | ø 18.5mm",
      "19 | 60mm | ø 18.8mm","20 | 61mm | ø 19.2mm","21 | 62mm | ø 19.5mm","22 | 63mm | ø 19.8mm","23 | 64mm | ø 20.2mm",
      "24 | 65mm | ø 20.5mm","25 | 66mm | ø 20.8mm","26 | 67mm | ø 21.2mm","27 | 68mm | ø 21.5mm","28 | 69mm | ø 21.8mm",
      "29 | 70mm | ø 22.2mm","30 | 71mm | ø 22.5mm","31 | 72mm | ø 22.8mm","32 | 73mm | ø 23.2mm","33 | 74mm | ø 23.5mm",
      "34 | 75mm | ø 23.8mm","35 | 75mm | ø 24.2mm"
    ];

    const womanSizes = [
      "6 | 46mm | ø 14.5mm","7 | 47mm | ø 14.8mm","8 | 48mm | ø 15.2mm","9 | 49mm | ø 15.5mm","10 | 50mm | ø 15.8mm",
      "11 | 51mm | ø 16.2mm","12 | 53mm | ø 16.5mm","13 | 54mm | ø 16.8mm","14 | 55mm | ø 17.2mm","15 | 56mm | ø 17.5mm",
      "16 | 57mm | ø 17.8mm","17 | 58mm | ø 18.2mm","18 | 59mm | ø 18.5mm","19 | 60mm | ø 18.8mm","20 | 61mm | ø 19.2mm",
      "21 | 62mm | ø 19.5mm","22 | 63mm | ø 19.8mm","23 | 64mm | ø 20.2mm","24 | 65mm | ø 20.5mm","25 | 66mm | ø 20.8mm"
    ];

    // Populate dropdowns
    manSizes.forEach((size) => {
      const opt = document.createElement('option');
      opt.value = size;
      opt.textContent = size;
      manSelect.appendChild(opt);
    });

    womanSizes.forEach((size) => {
      const opt = document.createElement('option');
      opt.value = size;
      opt.textContent = size;
      womanSelect.appendChild(opt);
    });

    // --- Initial state ---
    atcButton.disabled = true;
    atcButton.style.cursor = 'not-allowed';
    atcOverlay.style.pointerEvents = 'auto';
    atcOverlay.style.cursor = 'not-allowed';

    const baseWeight = parseInt(womanSizes[0].split(' | ')[0], 10) + parseInt(manSizes[0].split(' | ')[0], 10);

    // --- Functions ---
    function validateSelections() {
      const womanValue = parseInt(womanSelect.value?.split(' | ')[0], 10);
      const manValue = parseInt(manSelect.value?.split(' | ')[0], 10);
      const totalWeight = womanValue + manValue - baseWeight;
      const womanSelected = womanSelect.value !== '';
      const manSelected = manSelect.value !== '';
      const bothSelected = womanSelected && manSelected;

      const infWomanSelect    = document.querySelector('[id^="womans_ring_size"]');
      const infManSelect      = document.querySelector('[id^="mans_ring_size"]');
      infManSelect.value = manValue;
      infWomanSelect.value = womanValue;

      if (bothSelected) {
        atcButton.disabled = false;
        atcButton.style.cursor = 'pointer';
        atcOverlay.style.pointerEvents = 'none';
        atcOverlay.style.cursor = 'default';
      } else {
        atcButton.disabled = true;
        atcButton.style.cursor = 'not-allowed';
        atcOverlay.style.pointerEvents = 'auto';
        atcOverlay.style.cursor = 'not-allowed';
      }

      updateHiddenInputs();
      updateSelectedSize();
      updateWeight();
      syncPrice();
    }

    function updateHiddenInputs() {
      womanHidden.value = womanSelect.value || '';
      manHidden.value = manSelect.value || '';
    }

    function updateSelectedSize() {
      let text = 'Selected size is: ';
      if (womanSelect.value) text += `Woman - ${womanSelect.value}; `;
      if (manSelect.value) text += `Man - ${manSelect.value};`;
      if (!womanSelect.value && !manSelect.value) text += 'None';
      selectedSizeDiv.textContent = text;
    }

    function updateWeight() {
      const womanValue = parseInt(womanSelect.value?.split(' | ')[0], 10);
      const manValue = parseInt(manSelect.value?.split(' | ')[0], 10);
    
      let totalWeight;
    
      if (!isNaN(womanValue) && !isNaN(manValue)) {
        totalWeight = womanValue + manValue - baseWeight;
        totalWeightDiv.textContent = 'Total weight: ' + totalWeight;
      } else {
        totalWeightDiv.textContent = 'Please select sizes';
        return;
      }

      const dropdownAlt = document.getElementById('Size Pricing-0-0');
      if (dropdownAlt) {
        dropdownAlt.value = totalWeight;
        dropdownAlt.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function showValidationMessage() {
      validationMessage.classList.remove('fade-out');
      validationMessage.classList.add('show');
      validationMessage.style.visibility = 'visible';
      setTimeout(() => {
        validationMessage.classList.add('fade-out');
        setTimeout(() => {
          validationMessage.classList.remove('show', 'fade-out');
          validationMessage.style.visibility = 'hidden';
        }, 500);
      }, 2000);
    }

    function syncPrice() {
      if (!infPrice || !weddingPrice) return;
      weddingPrice.textContent = infPrice.textContent.trim();
      let oldPrice = weddingPrice.textContent;

      const observer = new MutationObserver(() => {
        const newPrice = infPrice.textContent.trim();
        if (newPrice !== oldPrice) {
          oldPrice = newPrice;
          weddingPrice.textContent = newPrice;
          observer.disconnect();
        }
      });

      observer.observe(infPrice, { characterData: true, subtree: true });
    }

    //INFINITE OPTIONS OBSERVER
     const observer = new MutationObserver((mutations) => {
     const el = document.getElementById('infiniteoptions-container');
       if (el) el.style.display = 'none';
     });
  
    observer.observe(document.body, { childList: true, subtree: true });
  
    const el = document.getElementById('infiniteoptions-container');
    if (el) el.style.display = 'none';
    //INFINITE OPTIONS OBSERVER

    // --- Event listeners ---
    womanSelect.addEventListener('change', validateSelections);
    manSelect.addEventListener('change', validateSelections);
  //dropdownAlt.addEventListener('change', validateSelections);

    atcOverlay.addEventListener('click', (e) => {
      if (atcButton.disabled) {
        e.preventDefault();
        showValidationMessage();
      }
    });

    atcButton.addEventListener('click', () => {
      const originalButton = document.querySelector('.product-actions.add-to-cart-enabled button');
      if (originalButton && !atcButton.disabled) {
        originalButton.click();
      }
    });

    // --- Initial setup ---
    //validateSelections();
    syncPrice();
  });
})();
